var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlickfangIconCircleArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M34.54,27.34 28.59,33.12 28.59,18 25.89,18 25.89,33.11 19.95,27.34 18.06,29.27 27.24,38.2 36.42,29.27z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.5,55C12.34,55,0,42.66,0,27.5C0,12.34,12.34,0,27.5,0C42.66,0,55,12.34,55,27.5C55,42.66,42.66,55,27.5,55z  M27.5,2.7C13.83,2.7,2.7,13.82,2.7,27.5s11.13,24.8,24.8,24.8s24.8-11.13,24.8-24.8S41.18,2.7,27.5,2.7z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlickfangIconCircleArrowBlack);
export default __webpack_public_path__ + "static/media/Blickfang_Icon-circle-arrow-black.bc95462330b6df64d431a3c5ee115ad0.svg";
export { ForwardRef as ReactComponent };